import React from 'react';
import PropTypes from 'prop-types';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import styles from './styles/LoginFormStyles';
import {Card, CardText} from 'material-ui/Card';
import {Grid, Row, Col} from 'react-flexbox-grid/lib';

import LoginFormBox from './LoginFormBox';
import CardMedia from 'material-ui/Card/CardMedia';
import CalAmpLogo from 'Content/Assets/images/CalAmp.png';
import icnImg from 'Content/Assets/images/crashboxx/Instant Crash Alerts_2.png';
import icnPlusImg from 'Content/Assets/images/crashboxx/Accident Reconstruction_2.png';
import dentImg from 'Content/Assets/images/crashboxx/Predictive phycsical damage_2.png';
import biteImg from 'Content/Assets/images/crashboxx/Predictive Bodilyy Injury_2.png';

class LoginForm extends React.Component {
    render() {
        const {formData, isAuthenticating, handleLogin, handleListChange, handleChange, translate} = this.props;
        const currentYear = new Date().year;

        return (
            <Grid className={"animated fadeIn"} style={styles.gridContainer} >
                <Row>
                    <Col xs={12} sm={12} md={6} style={styles.leftBoxContainer} >
                        <Card style={styles.leftCardContainer} >
                            <CardText style={styles.leftCardTextTitle} >
                                <h2 style={styles.h2} >
                                    {translate('GLOBAL.welcome')}
                                </h2>
                                <h1 style={styles.h2}>
                                    {translate('GLOBAL.apptitle')}
                                </h1>
                                <p>
                                    {translate('GLOBAL.appSubTitle')}
                                </p>
                            </CardText>
                            <CardText style={styles.leftCardTextContent} >
                                <Row>
                                    <Col xs={12} sm={6} >
                                        <LoginFormBox title={translate('MENU.ICN')} logo={icnImg} />
                                    </Col>
                                    <Col xs={12} sm={6} >
                                        <LoginFormBox title={translate('MENU.ICNPlus')} logo={icnPlusImg}  />
                                    </Col>
                                    <Col xs={12} sm={6} >
                                        <LoginFormBox title={translate('MENU.dent')} logo={dentImg}  />
                                    </Col>
                                    <Col xs={12} sm={6} >
                                        <LoginFormBox title={translate('MENU.bite')} logo={biteImg}  />
                                    </Col>
                                </Row>
                            </CardText>
                        </Card>
                    </Col>
                    <Col xs={12}  sm={12} md={6} >
                        <Card style={styles.rightCardContainer} >
                            <CardMedia style={styles.calAmpMediaCard} >
                                <img src={CalAmpLogo} width={"90%"} alt="CalAmp" />
                            </CardMedia>
                            <CardText style={{padding: 1}} >
                                <ValidatorForm
                                    ref="form"
                                    onSubmit={handleLogin}
                                    debounceTime={1000} >
                                <div>
                                    <Paper style={styles.paper}>
                                        <TextValidator
                                            fullWidth={true}
                                            hintText={translate('LoginForm.usernamePlaceholder')}
                                            onChange={handleChange}
                                            name="username"
                                            value={formData.username}
                                            validators={['required']}
                                            errorMessages={[translate('LoginForm.usernameIsRequired')]}
                                        />

                                        <TextValidator
                                            type="password"
                                            hintText={translate('LoginForm.passwordPlaceholder')}
                                            onChange={handleChange}
                                            name="password"
                                            value={formData.password}
                                            validators={['required']}
                                            errorMessages={[translate('LoginForm.passwordIsRequired')]}
                                            fullWidth={true}
                                        />

                                        {
                                            formData.isCalAmpListVisible ?

                                            <SelectField
                                                required={true}
                                                name="selectedAppId"
                                                value={formData.selectedAppId}
                                                floatingLabelText={translate('GLOBAL.selectedApplication')}
                                                fullWidth={true}
                                                onChange={handleListChange}>
                                                {
                                                formData.formattedAmpKeys.map(key => {
                                                    return <MenuItem key={key.id} value={key.id} primaryText={key.text} />
                                                })
                                                }
                                            </SelectField>
                                        :
                                            <div></div>
                                        }
                                        <div style={styles.buttonContainer} >
                                            <RaisedButton
                                                fullWidth={true}
                                                type="submit" name="action"
                                                label={!isAuthenticating ? translate('LoginForm.login'): translate('LoginForm.logging') }
                                                primary={true}
                                                disabled={isAuthenticating}
                                                icon={isAuthenticating ? <CircularProgress size={25} />: <div></div>}
                                                style={styles.loginBtn}>
                                            </RaisedButton>
                                        </div>

                                    </Paper>
                                </div>
                                </ValidatorForm>
                            </CardText>
                            <CardText style={styles.footer} >
                                &copy;{currentYear}&nbsp;{translate('GLOBAL.companyName')}&nbsp;-&nbsp;{translate('GLOBAL.rightsReserved')}
                            </CardText>
                        </Card>
                    </Col>
                </Row>
            </Grid>

        );
    }
}

LoginForm.propTypes = {
    formData: PropTypes.object.isRequired,
    handleLogin: PropTypes.func,
    handleChange: PropTypes.func,
    handleListChange: PropTypes.func,
    isAuthenticating: PropTypes.bool
};


export default LoginForm;


// WEBPACK FOOTER //
// ./src/components/login/LoginForm.js